import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_CAMPAIGN_RULES, GET_CAMPAIGN_RULES_SUCCESS, GET_CAMPAIGN_RULES_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getCampaignRules({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { campaignId } = payload?.urlParams || {};

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaigns/${campaignId}/campaign-rules`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CAMPAIGN_RULES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CAMPAIGN_RULES_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CAMPAIGN_RULES_ERROR, payload: error });
  }
}

export function* watchgetCampaignRules() {
  yield takeEvery(GET_CAMPAIGN_RULES, getCampaignRules);
}

function* getCampaignRulesSaga() {
  yield all([fork(watchgetCampaignRules)]);
}

export default getCampaignRulesSaga;
